import { NBSP } from 'shared/constants/symbols';
import * as styles from './styles.css';
import { TG_LINK } from 'shared/constants/links';
import { Responsive, useDeviceType } from '@cian/ui-kit';
import { clsx } from 'clsx';
import { useApplicationContext } from 'shared/utils/applicationContext';

export const Footer: React.FC = () => {
  const device = useDeviceType();

  const { config } = useApplicationContext();

  const refferalLink = config.getStrict<string>('b2b-marketing-hosts-promo-frontend.referralProgramLink');

  return (
    <div className={clsx(styles['container'], styles[device])}>
      <div className={styles['wrapper']}>
        <div className={styles['title']}>
          Сразу получайте новости о{NBSP}посуточной аренде{NBSP}и{NBSP}станьте частью большого профессионального{NBSP}
          сообщества
        </div>
        <a href={TG_LINK} target="_blank" rel="noopener noreferrer" className={styles['tg-container']}>
          <div className={styles['tg-icon']} />
          <div className={styles['tg-text']}>
            Присоединяйтесь к{NBSP}Циан{NBSP}Посуточно
          </div>
        </a>
        <Responsive desktop>
          <div className={styles['links']}>
            <a className={styles['footer-link']} target="_blank" rel="noopener noreferrer" href={refferalLink}>
              Правила реферальной программы
            </a>
            <a className={styles['footer-mail']} href="mailto:booking@cian.ru">
              booking@cian.ru
            </a>
          </div>
        </Responsive>
      </div>
    </div>
  );
};
